import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container, 
  Paper, 
  IconButton 
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <Container 
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center'
      }}
    >
      <Paper 
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 2,
          width: '100%',
          maxWidth: 450,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        <IconButton 
          sx={{
            bgcolor: 'error.light',
            color: 'error.contrastText',
            width: 120,
            height: 120,
            '&:hover': {
              bgcolor: 'error.main'
            }
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64 }} />
        </IconButton>

        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 'bold', 
            color: 'text.primary',
            mb: 2 
          }}
        >
          Access Restricted
        </Typography>

        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.secondary', 
            mb: 3,
            px: 2
          }}
        >
          You do not have the necessary permissions to view this page. 
          This area is restricted to RouteEye Admin organization members.
        </Typography>

        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: 2 
          }}
        >
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => navigate('/dashboard')}
            sx={{ 
              textTransform: 'none',
              px: 3,
              py: 1.5
            }}
          >
            Return to Dashboard
          </Button>

          <Button 
            variant="outlined" 
            color="secondary"
            onClick={() => navigate('/contact')}
            sx={{ 
              textTransform: 'none',
              px: 3,
              py: 1.5
            }}
          >
            Contact Support
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}